import store from '..'
import axios from 'axios'
import ls from 'localstorage-slim'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    siteid: null,
    requestId: null,
    agree: null,
    userInfo: null,
    accesstoken: null,
    apikey: null,
    sitePlan: 'basic',
    userRole: 'manager',
    account: null,
    superadmin: false,
    siteadmin: false,
    istayKey: null,
    isLogin: false
  },
  mutations: {
    updateMyAccount (state, data) {
      Object.assign(state.account, data)
    },
    setApiKey (state, key) {
      // axios 인터셉터 설정
      axios.interceptors.request.use(
        (config) => {
          // 요청 설정에 skipInterceptor가 true인 경우 인터셉터 동작 제외
          if (config.skipInterceptor) {
            return config
          }
          // 일반 요청에 대해 API 키 추가
          const apiKey = localStorage.getItem('apiKey') || config.headers['x-api-key']
          if (apiKey) {
            config.headers['x-api-key'] = apiKey
          }
          return config
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
  },
  actions: {
    async getMyAccount ({ state, dispatch }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-manage',
          func: 'get-my-account',
          id: store.state.authentication.requestId
        })
        state.account = res.data.message
        return res.data
      } catch (ex) {
        const status = ex?.response?.data?.message?.code
        const needChangePassword = status === 201 || status === 202
        const locale = store.getters['service/getLocale']
        if (status === 201) alert(`${locale.change_pw_desc}\n${locale.change_pw_security_policy}`)
        if (status === 202) alert(`${locale.change_pw_more_than}\n${locale.change_pw_desc}`)
        if (needChangePassword) {
          dispatch('logout')
          sessionStorage.setItem('tempUserId', userId)
          router.push({
            name: 'ChangePassword',
            params: {
              code: `${status}`
            }
          })
        }
        console.log(ex)
        return ex.response.data
      }
    },
    setAuthState ({ state }) {
      const key = ls.get('istayKey')
      if (key) {
        const siteid = key.siteid
        if (siteid) {
          localStorage.setItem('siteid', siteid)
        }
        state.siteid = siteid
        state.requestId = key.userid
        state.userInfo = {
          nickname: key.nickname,
          siteid: key.siteid
        }
        state.sitePlan = key.sitePlan
        state.userRole = key.userRole
        state.agree = true
        state.isLogin = key.isLogin
      }
      return key
    },
    setAuthInfo ({ state, dispatch }) {
      return dispatch('setAuthState').then((res) => {
        // 로그인한 상태이면 동의여부 체크
        if (res) {
          // superadmin은 동의여부 체크안함 (t.xxx)
          const pattern = /^t\d/ // t{N}.siteid
          const pattern2 = /^a\./ // a.siteid
          const isSuperadmin = pattern.test(state.requestId)
          const isSiteadmin = pattern2.test(state.requestId)
          state.superadmin = isSuperadmin
          state.siteadmin = isSiteadmin
          if (isSuperadmin) {
            return true
          } else {
            return dispatch('getUserConfig').then((res) => {
              // return res.message.castitAgree
              return true
            })
          }
        } else {
          return res
        }
      })
    },
    async login ({ state, commit, dispatch }, data) {
      const pw = await store.dispatch('util/dataEncryption', data.pw)
      return axios.post(`${API.BASE_URL}/system/auth`, {
        cmd: 'sc-login',
        username: data.uid,
        pw: pw
      }).then(res => {
        const info = { ...res.data.body, userid: data.uid, isLogin: true }
        const getUrlParams = function () {
          const params = {}
          window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (_str, key, value) {
            params[key] = value
          })
          return params
        }
        const isRequestDev = getUrlParams().debug && getUrlParams().debug === '1'
        const isLocal = window.location.origin.includes('localhost')
        ls.set('istayKey', info)
        localStorage.setItem('siteid', info.siteid)
        // 백엔드 prod && !프론트 localhost
        if (!isRequestDev && !isLocal) {
          axios.defaults.withCredentials = true
        }
        return dispatch('setAuthInfo').then(() => {
          return res
        })
      }).catch((ex) => {
        // alert(ex)
        console.log(ex)
        return ex.response
      })
    },
    async logout ({ state }) {
      const loginUid = state.requestId
      // localStorage.clear()
      if (loginUid) {
        localStorage.setItem('loginUid', loginUid)
      }
      ls.remove('istayKey')
      state.requestId = null
      state.userInfo = null
      state.accesstoken = null
      state.apikey = null
      state.sitePlan = 'basic'
      state.userRole = 'manager'
      state.agree = null
      state.istayKey = null
      state.isLogin = false
      await axios.post(`${API.BASE_URL}/system/auth`, {
        cmd: 'sc-logout'
      }, { widthCredentials: true })
      return true
    },
    async changePassword ({ state, commit, dispatch }, data) {
      const oldPw = await store.dispatch('util/dataEncryption', data.oldPw)
      const newPw = await store.dispatch('util/dataEncryption', data.newPw)
      try {
        const res = await axios.post(`${API.BASE_URL}/system/auth`, {
          cmd: 'sc-password',
          siteid: data.siteid,
          id: data.id,
          oriPassword: oldPw,
          password: newPw
        })
        return res?.status === 200 ? res : res?.data?.message
      } catch (ex) {
        console.log(ex)
        return ex?.response?.data?.message
      }
    },
    async getUserConfig ({ state }) {
      const key = ls.get('istayKey')
      const siteid = key.siteid
      return axios.post(`${API.BASE_URL}/castit/file`, {
        ...API.GET_USER_CONFIG,
        id: `a.${siteid}`
      }).then(res => {
        state.agree = true
        return res.data
      }).catch((ex) => {
        // alert(ex)
        console.log(ex)
        return ex.response.data
      })
    },
    async updateUserConfig ({ state, dispatch }, data) {
      return axios.post(`${API.BASE_URL}/castit/file`, {
        ...API.UPDATE_USER_CONFIG,
        id: store.state.authentication.requestId,
        ciPayload: data
      }).then(res => {
        if (res.status === 200) {
          dispatch('getUserConfig')
        }
        return res.data
      }).catch((ex) => {
        alert(ex)
        console.log(ex)
        return ex.response.data
      })
    }
  },
  getters: {
    isLogin: state => state.isLogin,
    accesstoken: state => {
      return state.accesstoken != null
    },
    apikey: state => {
      return state.apikey
    },
    getUserInfo: state => {
      return state.userInfo
    },
    getAuthInfo: state => {
      return {
        sitePlan: state.sitePlan,
        userRole: state.userRole
      }
    },
    getMyAccount: state => state.account,
    getAuthority: state => state.superadmin,
    getAuthoritySite: state => state.siteadmin
  }
}
